import {
    ADMINISTRATION,
    LIGHTING_PROFESSIONAL,
    MARKETPLACE,
    PLANNING,
    PRODUCTION_CONNECT,
    PRODUCTION_PROFESSIONAL,
    PROFILES,
    RESERVATION_PROFESSIONAL,
    SUPPLIER
} from '../common/nav/apps';
import { useContext, useMemo } from 'react';
import { UserContext } from '../common/auth/UserContext';

export default () => {
    const { application } = useContext(UserContext);

    const uriByApp = useMemo(() => {
        return {
            [ADMINISTRATION.id]: `${application.home}/peopleresources`,
            [PROFILES.id]: `${application.home}/people`,
            [MARKETPLACE.id]: `${application.home}/people`,
            [SUPPLIER.id]: `${application.home}/people`,
            [PLANNING.id]: `${application.home}/people`,
            [PRODUCTION_PROFESSIONAL.id]: `${application.home}/people`,
            [RESERVATION_PROFESSIONAL.id]: `${application.home}/people`,
            [PRODUCTION_CONNECT.id]: `${application.home}/people`,
            [LIGHTING_PROFESSIONAL.id]: `${application.home}/people`
        };
    }, []);

    return uriByApp[application.id];
};
